// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__19CqJ","modalForm":"UpgradeEpcsModal_modalForm__20IZF","modalFooter":"UpgradeEpcsModal_modalFooter__1f3HY"};